import React from "react";
import { Link } from "react-router-dom";

const SearchBar = ({ placeholder = "Search", onSearch, children }) => {
  return (
    <div className="card shadow-none d-flex flex-row align-items-center p-0">
      <div className="input-group border-0 mr-2">
        <div className="input-group-prepend border-0">
          <span className="input-group-text border-0">
            <i className="fa fa-search text-gray-400"></i>
          </span>
        </div>
        <input
          type="text"
          className="form-control border-0"
          placeholder={placeholder}
          aria-label="Search"
          onChange={(e) => onSearch && onSearch(e.target.value)}
        />
      </div>

      <div>{children}</div>
    </div>
  );
};

export default SearchBar;
